@if (dataset().id !== latestVersion()?.id) {
  <div class="banner mat-bg-surface-variant mat-text-on-surface-variant mat-corner-xs">
    <span>This is an older, archived version of the dataset.</span>

    <div class="banner-actions">
      <a mat-button [routerLink]="['/dataset', latestVersion()?.id]">Go to latest version</a>
    </div>
  </div>
}

<div class="npdc-title">
  <h1>{{ dataset().content.title }}</h1>

  @if (versions().length || mayUpdate()) {
    <div class="npdc-title__actions">
      @if (versions().length > 1) {
        <button matButton [matMenuTriggerFor]="versionMenu" matTooltip="Select a version of the dataset">
          <mat-icon>arrow_drop_down</mat-icon>
          <ng-container
            [ngTemplateOutlet]="datasetVersionName"
            [ngTemplateOutletContext]="{ dataset: dataset() }"
            ></ng-container>
        </button>

        <mat-menu #versionMenu="matMenu">
          @for (version of versions(); track version.id) {
          <a mat-menu-item [routerLink]="['/dataset', version.id]">
            <ng-container
              [ngTemplateOutlet]="datasetVersionName"
              [ngTemplateOutletContext]="{ dataset: version }"
              ></ng-container>
            @if (version.id === latestVersion()?.id) {
              (latest)
            }
          </a>
          }
        </mat-menu>
      }

      @if (mayUpdate()) {
        @if (dataset().type === 'draft') {
          <button mat-flat-button (click)="publish()">Publish</button>
        } @else if (dataset().type === 'public' && dataset().id === latestVersion()?.id) {
          <button mat-button (click)="createNewVersion()">New version</button>
        }
        <button mat-button [routerLink]="'edit'" matTooltip="Edit dataset metadata">Edit</button>
        <button mat-icon-button [matMenuTriggerFor]="optionsMenu" matTooltip="More actions">
          <mat-icon>more_vert</mat-icon>
        </button>
      }
    </div>
  }
</div>

<nav mat-tab-nav-bar [tabPanel]="tabPanel">
  <a mat-tab-link routerLink="." [active]="currentRoute() === ''"
    ><mat-icon>article</mat-icon>Metadata</a
  >
  <a mat-tab-link routerLink="file" [active]="currentRoute().startsWith('file')"
    ><mat-icon>folder</mat-icon>Files</a
  >
  @if (hasRecords()) {
    <a mat-tab-link routerLink="record" [active]="currentRoute().startsWith('record')"
      ><mat-icon>data_object</mat-icon>Records</a
    >
  }
</nav>
<mat-tab-nav-panel #tabPanel>
  <router-outlet></router-outlet>
</mat-tab-nav-panel>

<mat-menu #optionsMenu>
  <button mat-menu-item [routerLink]="['/dataset', dataset().id, 'permission']">
    Manage permissions
  </button>
  <button mat-menu-item [disabled]="dataset().type !== 'draft'"
    (click)="delete()">Delete</button>
</mat-menu>

<ng-template #publishPromptTemplate>
  <p>This action will</p>

  <ul>
    <li>Activate the reserved DOI.</li>
    <li>Make the dataset publicly visible (no login required).</li>
    <li>Lock attached files in place (they can no longer be removed).</li>
    <li>Archive (unlist) the parent dataset.</li>
  </ul>
</ng-template>

<ng-template #datasetVersionName let-dataset="dataset">
  @let published = dataset.published;
  @if (published === "0001-01-01T00:00:00Z") {
    Pending draft
  } @else {
    {{ published | date:'yyyy-MM-dd HH:mm:ss':'UTC' }}
  }
</ng-template>
